const addSpace = (preview: string) => (preview.length > 1 ? true : '')

export const formatInTextPreview = ({
  contributorsSelected,
  contributorsValue,
  isMLA,
  titleSelected,
  titleValue,
  yearSelected,
  yearValue,
  identifiersSelected,
  identifiersValue,
  isHarvardCiteThemRight10,
}) => {
  const first = '('
  const last = ')'
  const comma = ','
  const space = ' '
  let preview = ''
  preview += first
  if (contributorsSelected && contributorsValue) {
    preview += contributorsValue
    preview += addSpace(preview) && isMLA ? '' : comma

    if (isHarvardCiteThemRight10 && preview.includes('et al.')) {
      preview = preview.replace('et al.', '<i>et al.</i>')
    }
  }
  if (titleSelected && titleValue) {
    preview += `${addSpace(preview) && space}<i>${titleValue}</i>`
  }
  if (yearSelected && yearValue) {
    preview += (addSpace(preview) && space) + yearValue
  }
  if (identifiersSelected && identifiersValue) {
    preview += (addSpace(preview) && space) + identifiersValue
  }
  if (preview.endsWith(comma)) {
    preview = preview.slice(0, -1)
  }
  preview += last
  return preview
}

export const formatFootnotePreview = ({ footnote, locator }) => {
  if (!footnote) {
    return `${locator}.`
  }
  const footnotePreview = footnote.replace(/\.$/, '')
  return `${footnotePreview}, ${locator}.`
}
